import {
  ADJUVANT_STEP_GROUP_KEY,
  BIOSTIMULANT_STEP_GROUP_KEY,
  OPERATION_STEP_GROUP_KEY,
  PLANTPROTECTION_STEP_GROUP_KEY,
  PRODUCTION_STEP_GROUP_KEY,
  SEED_STEP_GROUP_KEY,
  SEEDDRESS_STEP_GROUP_KEY,
  SOILINPUT_STEP_GROUP_KEY,
} from 'constants/uiConstants';
import { InputStepType } from 'interfaces/IInputStep';

import { type StepSelectorGroup } from './stepConfig';

// Array order is the picker tab order (OP-2434). Operation, Plant Protection,
// Adjuvant, Soil Input, Biostimulant, Seed, and Seed Treatment
// are sourced live from GC/MC via their respective use*Catalogue hooks
// (see StepInputSelector.tsx's isCatalogueGroup branch) — these group entries
// only carry the key/label/stepType needed to build the tab list; their
// `options` are never read.
export const STEP_SELECTOR_GROUP_DATA: StepSelectorGroup[] = [
  {
    key: SEED_STEP_GROUP_KEY,
    label: 'Seed',
    stepType: InputStepType.Seed,
    options: [],
  },
  {
    key: SEEDDRESS_STEP_GROUP_KEY,
    label: 'Seed Treatment',
    stepType: InputStepType.SeedDress,
    options: [],
  },
  {
    key: PLANTPROTECTION_STEP_GROUP_KEY,
    label: 'Plant Protection',
    stepType: InputStepType.CropProtection,
    options: [],
  },
  {
    key: ADJUVANT_STEP_GROUP_KEY,
    label: 'Adjuvant',
    stepType: InputStepType.Adjuvant,
    options: [],
  },
  {
    key: SOILINPUT_STEP_GROUP_KEY,
    label: 'Soil Input',
    stepType: InputStepType.SoilInput,
    options: [],
  },
  {
    key: OPERATION_STEP_GROUP_KEY,
    label: 'Operation',
    stepType: InputStepType.Application,
    options: [],
  },
  {
    key: BIOSTIMULANT_STEP_GROUP_KEY,
    label: 'Biostimulant',
    stepType: InputStepType.Biostimulant,
    options: [],
  },
  {
    key: PRODUCTION_STEP_GROUP_KEY,
    label: 'Production',
    stepType: InputStepType.Production,
    // Placeholder harvested products until the Production catalogue
    // collection exists. Operations such as harvest or carting are added to
    // a Production task as Operation costs, $/ha or per t (OP-2399).
    options: [
      { label: 'Grain', item: 'Grain', globalId: null },
      { label: 'Grain Pulse', item: 'Grain Pulse', globalId: null },
      { label: 'Grain Seed', item: 'Grain Seed', globalId: null },
      { label: 'Grain Stockfeed', item: 'Grain Stockfeed', globalId: null },
    ],
  },
];
